import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Logo } from "@/components/Logo";
import { SupportLine } from "@/components/SupportLine";
import { useI18n, usePageTitle } from "@/i18n";

// Cancel page. No payment was taken. The previously stored pending plan selection
// is left unchanged. Nothing is activated and no credits are granted.
export default function CheckoutCancel() {
  const { t } = useI18n();
  usePageTitle("titles.checkoutCancel");
  return (
    <div className="flex min-h-screen items-center justify-center bg-re-soft px-6 py-16" data-testid="checkout-cancel-page">
      <div className="w-full max-w-md rounded-2xl border border-re-line bg-white p-8 text-center shadow-sm">
        <Link to="/dashboard" className="mb-6 inline-flex justify-center"><Logo /></Link>
        <XCircle className="mx-auto h-12 w-12 text-re-muted" />
        <h1 className="mt-4 font-heading text-2xl font-bold text-re-charcoal" data-testid="checkout-cancel-title">{t("app.checkout.cancelTitle")}</h1>
        <p className="mx-auto mt-3 max-w-sm text-sm text-re-muted">
          {t("app.checkout.cancelText")}
        </p>
        <div className="mt-7 flex flex-col gap-3">
          <Link to="/account/billing" data-testid="checkout-cancel-retry"
            className="rounded-full bg-re-charcoal px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-black">
            {t("app.checkout.tryAgain")}
          </Link>
          <Link to="/dashboard" data-testid="checkout-cancel-dashboard"
            className="rounded-full border border-re-line px-6 py-3 text-sm font-semibold text-re-ink transition-colors hover:border-re-charcoal">
            {t("app.checkout.backToDashboard")}
          </Link>
        </div>
        <div className="mt-6 border-t border-re-line pt-4">
          <SupportLine className="justify-center" testid="checkout-cancel-support" />
        </div>
      </div>
    </div>
  );
}
